import script from "./VideoViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoViewer.vue?vue&type=script&setup=true&lang=js"

import "./VideoViewer.vue?vue&type=style&index=0&id=5cfb2010&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfb2010"]])

export default __exports__